import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { StablecoinAddressFilterState, StablecoinAddressType, StablecoinFilterState, StablecoinFiltersResponse, StablecoinTransactionType } from '@/types/stablecoin';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type StablecoinState = {
  data: StablecoinTransactionType[];
  pagination: PaginationAPI;
  loading: boolean;
  filters: StablecoinFilterState;
  filterOptions?: StablecoinFiltersResponse;
  addressData: StablecoinAddressType[];
  addressPagination: PaginationAPI;
  addressFilters: StablecoinAddressFilterState;
};

export const stablecoinInitialState: StablecoinState = {
  data: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
  filters: {},
  addressData: [],
  addressPagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  addressFilters: {},
};

const slice = createSlice({
  name: 'stablecoin',
  initialState: stablecoinInitialState,
  reducers: {
    setListStablecoinAction(
      state,
      action: PayloadAction<{
        data: StablecoinTransactionType[];
        pagination?: PaginationAPI;
      }>,
    ) {
      const { payload } = action;
      state.data = payload.data;
      state.pagination = payload.pagination || state.pagination;
    },

    setListStablecoinAddressAction(
      state,
      action: PayloadAction<{
        data: StablecoinAddressType[];
        pagination?: PaginationAPI;
      }>,
    ) {
      const { payload } = action;
      state.addressData = payload.data;
      state.addressPagination = payload.pagination || state.addressPagination;
    },

    setStablecoinFilterOptionsAction(
      state,
      action: PayloadAction<StablecoinFiltersResponse>,
    ) {
      state.filterOptions = action.payload;
    },

    setStablecoinFiltersAction(state, action: PayloadAction<StablecoinFilterState>) {
      state.filters = { ...state.filters, ...action.payload };
    },

    resetStablecoinFiltersAction(state) {
      state.filters = {};
    },

    setAddressFiltersAction(state, action: PayloadAction<StablecoinAddressFilterState>) {
      state.addressFilters = { ...state.addressFilters, ...action.payload };
    },

    resetAddressFiltersAction(state) {
      state.addressFilters = {};
    },
  },
});

export const {
  setListStablecoinAction,
  setListStablecoinAddressAction,
  setStablecoinFiltersAction,
  setStablecoinFilterOptionsAction,
  resetStablecoinFiltersAction,
  setAddressFiltersAction,
  resetAddressFiltersAction,
} = slice.actions;
export default slice.reducer;
